import {ServiceBase} from "../ServiceBase";
import {ISessionTimerService} from "./session-timer.service.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {observable, runInAction} from "mobx";

export class SessionTimerService extends ServiceBase implements ISessionTimerService {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        services.sdk.events.onSessionTimerUpdate(this._onSessionTimerUpdate);
        this.reaction(() => this.services.user.isAuthorized,
            (isAuthorized) => {
                if(!isAuthorized) {
                    this.currentSessionTimer = null;
                }
            });
    }

    private _onSessionTimerUpdate = (eventData: {sessionTime: TimeSpan}) => {
        runInAction(() => {
            this.currentSessionTimer = eventData.sessionTime;
        });
    }

    @observable.ref
    currentSessionTimer: TimeSpan | null = null;
}